import { toast } from 'react-toastify';

export const isEmpty = (value?: string | number | boolean | null) => {
  return value === '' || value === undefined || value === null;
};

export const isValidIP = (ip: string) => {
  const ipv4Pattern =
    /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){2}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

  return ipv4Pattern.test(ip);
};

export const copyToClipboard = (text: string) => {
  navigator.clipboard
    .writeText(text)
    .then(() => {
      toast('Токен успешно скопирован в буфер обмена!', { autoClose: 1000, hideProgressBar: true });
    })
    .catch((err) => {
      toast.error('Ошибка при копировании токена: ', err);
    });
};
